// extracted by mini-css-extract-plugin
export default {"pageBody":"index_pageBody_-6tWp","content_list":"index_content_list_9Js88","chip_item":"index_chip_item_-8MmL"};